import { useMutation } from '@tanstack/react-query'
import { agentsApi } from '../../api/agents-api'
import { agentKeys } from '../../api/query-keys'

export function useUpdateAgentReleaseChannel(entityId: string, agentId: string) {
  return useMutation({
    mutationFn: (channelId: string) =>
      agentsApi.updateAgentReleaseChannel(entityId, agentId, channelId),
    meta: { invalidates: [agentKeys.root] },
  })
}
